/* trewrld Cinematic Landing, Sept 2026. Reveal, hero film, scroll showcase, tilt cards, lightbox. No dependencies. */
(function () {
  'use strict';
  if (window.__trewrldCinema) return; window.__trewrldCinema = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;

  /* 1. Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.cin-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Hero background film (YouTube, muted loop). Poster stays until the player reports PLAYING. */
  function ytEmbed(id, opts) {
    var p = {
      autoplay: opts.autoplay ? 1 : 0, mute: opts.mute ? 1 : 0, controls: opts.controls ? 1 : 0,
      loop: opts.loop ? 1 : 0, playlist: opts.loop ? id : '', playsinline: 1, rel: 0, modestbranding: 1,
      iv_load_policy: 3, enablejsapi: 1, origin: location.origin
    };
    var q = Object.keys(p).filter(function (k) { return p[k] !== ''; }).map(function (k) { return k + '=' + encodeURIComponent(p[k]); }).join('&');
    return 'https://www.youtube-nocookie.com/embed/' + id + '?' + q;
  }
  function initHero() {
    document.querySelectorAll('.cin-hero[data-video]').forEach(function (hero) {
      var id = hero.getAttribute('data-video');
      if (!id || reduce) return;
      var slot = hero.querySelector('.cin-hero__media');
      var start = function () {
        if (hero.dataset.started) return; hero.dataset.started = '1';
        var f = document.createElement('iframe');
        f.className = 'cin-hero__frame';
        f.setAttribute('title', 'Background film');
        f.setAttribute('aria-hidden', 'true');
        f.setAttribute('tabindex', '-1');
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        f.src = ytEmbed(id, { autoplay: true, mute: true, controls: false, loop: true });
        slot.appendChild(f);
        window.addEventListener('message', function (ev) {
          if (ev.source !== f.contentWindow) return;
          var d; try { d = JSON.parse(ev.data); } catch (e) { return; }
          var playing = (d.event === 'onStateChange' && d.info === 1) || (d.event === 'infoDelivery' && d.info && d.info.playerState === 1);
          if (playing) hero.classList.add('is-playing');
          if (d.event === 'onReady' || d.event === 'alreadyInitialized') play();
        });
        function send(o) { try { f.contentWindow.postMessage(JSON.stringify(o), '*'); } catch (e) {} }
        function play() { send({ event: 'command', func: 'mute', args: [] }); send({ event: 'command', func: 'playVideo', args: [] }); }
        f.addEventListener('load', function () {
          send({ event: 'listening', id: 1, channel: 'widget' });
          /* Autoplay param alone is not always honoured; nudge the player (muted) a few times. */
          setTimeout(play, 800); setTimeout(play, 2500); setTimeout(play, 5000);
        });
      };
      /* Delay slightly so LCP (poster + heading) lands first. */
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 600);
    });
  }

  /* 3. Showcase scroll progress: writes --cin-p (0..1) per panel */
  function initShowcase() {
    var panels = document.querySelectorAll('.cin-panel');
    if (!panels.length || reduce) { panels.forEach(function (p) { p.style.setProperty('--cin-p', 1); }); return; }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      panels.forEach(function (p) {
        var r = p.getBoundingClientRect();
        var center = r.top + r.height / 2;
        /* progress 0 when panel centre is at bottom of viewport, 1 when it reaches ~45% from top, holds 1 after */
        var t = 1 - (center - vh * 0.45) / (vh * 0.55);
        t = Math.max(0, Math.min(1, t));
        p.style.setProperty('--cin-p', t.toFixed(3));
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 4. Tilt cards */
  function initTilt() {
    var cards = document.querySelectorAll('.cin-card');
    if (!cards.length || reduce || touch) return;
    cards.forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        c.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
        c.style.setProperty('--rx', ((0.5 - y) * 12).toFixed(2) + 'deg');
        c.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        c.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
    });
  }

  /* 5. Lightbox for "Watch the film" */
  var lb, lastFocus;
  function openLightbox(id, title) {
    lastFocus = document.activeElement;
    lb = document.createElement('div');
    lb.className = 'cin-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', title || 'Product film');
    lb.innerHTML = '<button class="cin-lb__close" type="button" aria-label="Close">&times;</button><div class="cin-lb__box"><iframe title="' + (title || 'Product film') + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen src="' + ytEmbed(id, { autoplay: true, mute: false, controls: true, loop: false }) + '"></iframe></div>';
    document.body.appendChild(lb);
    document.body.classList.add('cin-lb-open');
    requestAnimationFrame(function () { lb.classList.add('is-open'); lb.querySelector('.cin-lb__close').focus(); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('cin-lb__close')) closeLightbox(); });
    document.addEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') closeLightbox(); }
  function closeLightbox() {
    if (!lb) return;
    document.removeEventListener('keydown', onKey);
    lb.classList.remove('is-open');
    var el = lb; lb = null;
    setTimeout(function () { el.remove(); document.body.classList.remove('cin-lb-open'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }, 300);
  }
  function initLightbox() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cin-film]');
      if (!b) return;
      e.preventDefault();
      openLightbox(b.getAttribute('data-cin-film'), b.getAttribute('data-cin-title'));
    });
  }

  function init() { initReveal(); initHero(); initShowcase(); initTilt(); initLightbox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Re-init inside the Shopify theme editor when sections re-render */
  document.addEventListener('shopify:section:load', function () { initReveal(); initHero(); initShowcase(); initTilt(); });
})();
